import React from 'react';
import { DPage, DPageBody } from '../../../../dum';
import { MachinesListBlock } from './blocks/machine-list';

export function MachinesPage() {
    return (
        <DPage animated>
            <DPageBody disableGutters>
                <MachinesListBlock />
            </DPageBody>
        </DPage>
    );
}
